import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAfsls, fetchClientPortalSetting } from './thunks';
import { Afsl, ClientPortalSetting, ClientPortalSettingsState, SetClientPortalTogglePayload } from './types';

export const initialState: ClientPortalSettingsState = {
  afsls: [],
  afslId: undefined,
  setting: { afslId: 0, enableClientPortalReporting: false },
  savedSetting: { afslId: 0, enableClientPortalReporting: false },
};

export const clientPortalSettingsSlice = createSlice({
  name: '@@templates/clientPortal',
  initialState,
  reducers: {
    setAfslId: (state, action: PayloadAction<number | undefined>) => {
      state.afslId = action.payload;
    },
    setClientPortalToggle: (state, action: PayloadAction<SetClientPortalTogglePayload>) => {
      state.setting[action.payload.key] = action.payload.value;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClientPortalSetting.fulfilled, (state, action: PayloadAction<ClientPortalSetting>) => {
      state.setting = action.payload;
      state.savedSetting = action.payload;
    });
    builder.addCase(fetchAfsls.fulfilled, (state, action: PayloadAction<Afsl[]>) => {
      state.afsls = action.payload.sort((a, b) => a.name.localeCompare(b.name));
      if (!state.afslId && state.afsls.length > 0) {
        state.afslId = state.afsls[0].id;
      }
    });
  },
});
